import React, { ReactElement } from 'react';

const Keplr = ({
  idPrefix = '',
  className,
  ...props
}: {
  idPrefix?: string;
  className?: string;
}): ReactElement => (
  <svg
    className={className}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath={`url(#${idPrefix}-clip0)`}>
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint0_radial)`}
      />
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint1_radial)`}
        fillOpacity="0.68"
      />
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint2_radial)`}
        fillOpacity="0.2"
      />
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint3_linear)`}
        fillOpacity="0.03"
      />
      <path
        d="M9.03844 19V12.8L14.8993 19H18.1584V18.84L11.4193 11.7809L17.6384 5.08V5H14.3584L9.03844 10.913V5H6.39844V19H9.03844Z"
        fill="white"
      />
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint4_radial)`}
      />
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint5_radial)`}
        fillOpacity="0.57"
      />
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint6_radial)`}
        fillOpacity="0.68"
      />
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint7_radial)`}
        fillOpacity="0.08"
      />
      <path
        d="M18 2H6C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6L2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2V2Z"
        fill={`url(#${idPrefix}-paint8_linear)`}
        fillOpacity="0.03"
      />
      <path
        d="M9.03844 19V12.8L14.8993 19H18.1584V18.84L11.4193 11.7809L17.6384 5.08V5H14.3584L9.03844 10.913V5H6.39844V19H9.03844Z"
        fill="white"
      />
    </g>
    <defs>
      <radialGradient
        id={`${idPrefix}-paint0_radial`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-12.9556 11.5989) rotate(140.17) scale(34.3885 41.4984)"
      >
        <stop stopColor="#1973C8" />
        <stop offset="1" stopColor="#0D25D1" />
      </radialGradient>
      <radialGradient
        id={`${idPrefix}-paint1_radial`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-17.2058 -7.47143) rotate(178.313) scale(21.505 15.8382)"
      >
        <stop stopColor="#5CA6EB" />
        <stop offset="1" stopColor="#5CA6EB" stopOpacity="0.08" />
      </radialGradient>
      <radialGradient
        id={`${idPrefix}-paint2_radial`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-15.865 3.246) rotate(119.937) scale(11.4896 17.2254)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.33" />
      </radialGradient>
      <linearGradient
        id={`${idPrefix}-paint3_linear`}
        x1="19.1652"
        y1="16.4835"
        x2="0.316522"
        y2="4.69043"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.18" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <radialGradient
        id={`${idPrefix}-paint4_radial`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.1934 4.16383) scale(34.4)"
      >
        <stop stopColor="#2F80F2" />
        <stop offset="1" stopColor="#A942B5" />
      </radialGradient>
      <radialGradient
        id={`${idPrefix}-paint5_radial`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.20445 2.82657) scale(31.8209)"
      >
        <stop stopColor="#45F9DE" />
        <stop offset="1" stopColor="#A942B5" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id={`${idPrefix}-paint6_radial`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.0444 22.0735) scale(19.2087)"
      >
        <stop stopColor="#E957C5" />
        <stop offset="1" stopColor="#A942B5" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id={`${idPrefix}-paint7_radial`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.9692 11.9901) scale(11.5304)"
      >
        <stop stopOpacity="0.18" />
        <stop offset="1" stopColor="#101010" />
      </radialGradient>
      <linearGradient
        id={`${idPrefix}-paint8_linear`}
        x1="19.1652"
        y1="16.4835"
        x2="0.316522"
        y2="4.69043"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.18" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

export default Keplr;
